module.exports = __webpack_public_path__ + "static/ai-4-0463fb462355842d384190db9737c5aa.png";